import React from 'react';
import PropTypes from 'prop-types';
import SelectInput, { components } from 'react-select5';

import cancelIcon from 'images/new_ui/icons/cancel.svg';
import {
  white, primary200, primary400, primary600, primary,
  gray100, gray200, gray300, gray600, gray700, gray800, gray900,
  danger300, danger600,
} from 'components/new_ui/Colors';

function MultiValueRemove(props) {
  return (
    <components.MultiValueRemove {...props}>
      <img src={cancelIcon} alt="Remove" width="16px" height="16px" />
    </components.MultiValueRemove>
  );
}

const customTheme = (theme) => ({
  ...theme,
  borderRadius: '.375rem',
  colors: {
    ...theme.colors,
    primary,
    primary75: primary600,
    primary50: primary400,
    primary25: primary200,
    danger: danger600,
    dangerLight: danger300,
    neutral0: white,
    // neutral5: '#',
    neutral10: gray100,
    neutral20: gray200,
    neutral30: gray300,
    // neutral40: gray400,
    // neutral50: gray500,
    neutral60: gray600,
    neutral70: gray700,
    neutral80: gray800,
    neutral90: gray900,
  },
});

const customStyles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    borderColor: state.isFocused ? primary600 : gray300,
    boxShadow: 'none',
    ':hover': {
      borderColor: state.isFocused ? primary600 : gray300,
    },
  }),
  valueContainer: (baseStyles, _state) => ({
    ...baseStyles,
    maxHeight: '100px',
    overflow: 'auto',
    padding: '.5rem 1rem',
  }),
};

export default function Select(props) {
  const {
    id, label, hint, isMulti, isClearable,
  } = props;

  const labelElement = <label htmlFor={id} className="form-label">{label}</label>;
  const hintElement = <div className="form-text">{hint}</div>;

  return (
    <>
      {label.length ? labelElement : null}

      <SelectInput
        inputId={id}
        closeMenuOnSelect={!isMulti}
        isClearable={isClearable}
        components={{ MultiValueRemove }}
        theme={customTheme}
        styles={customStyles}
        {...props}
      />

      {hint.length ? hintElement : null}
    </>
  );
}

Select.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  hint: PropTypes.string,
  isMulti: PropTypes.bool,
  isClearable: PropTypes.bool,
};

Select.defaultProps = {
  label: '',
  hint: '',
  isMulti: false,
  isClearable: true,
};
